import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morphProductBlock } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * A custom element that displays a product title.
 * On a product page a combined listing swap re-renders the whole of <main>, but inside a quick add,
 * quick view or quick edit dialog only the components lining up with the variant update are touched.
 * The title has to be one of them, or the dialog keeps naming the product the shopper moved away from.
 */
class ProductTitle extends Component {
  /** @type {Element | null} - Cached section/dialog the variant listener is attached to. */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateTitle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateTitle);
  }

  /**
   * Updates the title.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateTitle = (event) => {
    morphProductBlock(this, event);
  };
}

if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}
